export const formatPrice = (value: number | undefined, suffix: string = "") => {
  if (!value || value === 0) {
    return "Sob consulta";
  }
  return `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${suffix}`;
};
